<template>
  <div v-if="isAdmin">
    <v-card>
      <v-card-title>
        Användare
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-if="users"
        v-model="selected"
        :headers="headers"
        :items="users"
        :search="search"
        item-key="id"
        show-select
        class="elevation-1"
        dense
      >
      </v-data-table>
    </v-card>
  </div>
</template>
<style>
</style>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {

  data: () => ({
    selected: [],
    search: '',
    headers: [
      {
        text: 'E-post',
        align: 'start',
        sortable: true,
        value: 'email'
      },
      { text: 'Användarnamn', value: 'username' },
      { text: 'Skapad', value: 'created_at' },
      { text: 'Abonnemang till', value: 'end_date' },
      { text: 'Senast inloggad', value: 'last_login' },
      { text: 'Antal system', value: 'system_ids.length' },
      { text: 'ID', value: 'id' }

    ]
  }),

  mounted () {
    this.fetchUsersAction()
  },

  methods: {
    ...mapActions(['fetchUsersAction'])
  },

  computed: {
    ...mapGetters(['isAdmin', 'users'])
  }
}
</script>
